// Import Packages
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState } from 'recoil';

// Import Pages
import TransformArea from '../TransformArea/TransformArea';
import ConnectorField from '../../../../../home/pages/automs/newFlow/middleArea/connectorField/ConnectorField';
import DeleteConfirm from "../../../../../components/DataTable/DeleteConfirm";

// Import Material UI Elements
import Button from '@material-ui/core/Button';

// Import Recoil
import { triggerConf, alertState } from '../../../../../recoil-store/recoil-state';


// Import Helpers
import { findActionById, isActionValueController } from "../../../../../helpers/helper";

// Import Icons
import CloseIcon from '../../../../../assets/icons/close-icon.svg';
import MenuOpenIcon from '@material-ui/icons/MenuOpen';
import DeleteIcon from '../../../../../assets/icons/trash-box'

function Transform({ baseAction, transformDetail, data, automDetail, variables,
    setOpenVariable, variableRender, openModalName, setOpenModalName, cancel, save, removeTransform }) {
    const [triggerConfig, setTriggerConfig] = useRecoilState(triggerConf);
    const [manipulations, setManipulations] = useState([]);
    const [showConfirm, setShowConfirm] = useState({ show: false, indexToRemove: -1 });
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const setAlert = useSetRecoilState(alertState);


    const label = "CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.DATA-TRANSFORM.";
    const { t } = useTranslation();


    useEffect(() => {
        if (transformDetail) {
            setManipulations(JSON.parse(JSON.stringify(transformDetail.manipulations)));
        } else {
            setManipulations([{}]);
        }
    }, [data.path])

    const addNewAction = () => {
        setManipulations([...manipulations, {}]);
    }

    const deleteAction = () => {
        if (manipulations.length > 1) {
            let updatedItems = manipulations.filter((item, index) => index !== showConfirm.indexToRemove)
            setManipulations(updatedItems);
        } else {
            setManipulations(prevArray => {
                const newArray = [...prevArray];
                newArray[showConfirm.indexToRemove] = {};
                return newArray;
            });
        }

        setShowConfirm({ show: false, indexToRemove: -1 });
    }

    const checkAndSave = () => {
        if (!manipulations && !manipulations.length) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + "EMPTY-TRANSFORM-ERROR"),
                severity: 'error'
            }))
        }

        for (const m of manipulations) {
            if (!m.action || !m.action.fields) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(label + 'ACTION-NOT-SELECTED'),
                    severity: 'error'
                }))
            }
            let res = isActionValueController(m.action.fields);
            if (res.indexOf(false) !== -1) {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t('ACTIVE-DIRECTORY.NOT-NULL'),
                    severity: 'error'
                }))
            }
            if (m.hasCondition) {
                if (!m.conditions || !m.conditions.length) {
                    return setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t(label + 'CONDITION-NOT-VALID'),
                        severity: 'error'
                    }))
                }

                for (const c of m.conditions) {
                    if (!c.operator || !c.condition || !c.fields.firstValue.value || (!c.fields.secondValue.value && c.operator !== 'nempty' && c.operator !== 'empty')) {
                        return setAlert(alert => ({
                            ...alert,
                            show: true,
                            message: t(label + 'CONDITION-NOT-VALID'),
                            severity: 'error'
                        }))
                    }
                }

            }
        }

        save(manipulations, data)
    }

    const showRemoveConfirm = (indexToRemove) => {
        setShowConfirm({ show: true, indexToRemove: indexToRemove });
    }

    return (
        <div className='transform-page'>
            <div className='transform-data-table-icon'>
                <MenuOpenIcon className='data-manager-icon-color' onClick={() => setOpenModalName(openModalName === "dataManager" ? "manipulation" : "dataManager")} />
            </div>
            <div className='items-center-between'>
                <div className='base-modal-title base-title-detail items-center'>
                    {t(label + "TRANSFORM-DATA")}
                    {transformDetail &&
                        <DeleteIcon onClick={() => setShowDeleteConfirm(true)} width={12} height={12} className="icon-cursor-pointer m-l-16" />}
                </div>
                <img className='transform-cancel-icon' src={CloseIcon} onClick={cancel} />
            </div>
            <div className='transform-sub-description'>
                {t(label + "TRANSFORM-DATA-DESC")}
                <div>
                    {t(label + (data.assignType === "different" ? "ASSIGN-TYPE-DIFFERENT" : "ASSIGN-TYPE-AVAILABLE"))}
                </div>
            </div>

            <div className='transform-content'>
                {
                    openModalName === "dataManager" &&
                    <ConnectorField automDetail={automDetail} action={baseAction} showFieldPreview={true}
                        triggerConfig={triggerConfig} triggerExpanded={true}
                        debugOpen={false} debugExpand={false}
                        onFlowPage={true}
                        setTriggerConf={setTriggerConfig} automId={automDetail.id}
                        automVersionId={automDetail.versionId} rightLocation={false}
                        variables={variables} setOpenVariable={setOpenVariable} resizeClassName="dialog-data-table" />
                }

                {
                    manipulations && manipulations.map((manipulation, index) => (
                        <TransformArea key={index} manipulation={manipulation} setManipulations={setManipulations} data={data}
                            index={index} automDetail={automDetail} baseAction={baseAction}
                            variables={variables} setOpenVariable={setOpenVariable} variableRender={variableRender}
                            addNewAction={addNewAction} deleteAction={showRemoveConfirm} />
                    ))
                }
            </div>

            <div>
                <div className='configuration-footer'>
                    <Button className='transform-submit-button' onClick={checkAndSave}>
                        {t(label + 'COMPLETE-CONFIGURATION')}
                    </Button>
                </div>
            </div>

            {showConfirm?.show &&
                <DeleteConfirm setOpenDelete={setShowConfirm}
                    message={t(label + "DELETE-ACTION-QUESTION")}
                    deleteFunc={deleteAction} />
            }

            {showDeleteConfirm &&
                <DeleteConfirm setOpenDelete={setShowDeleteConfirm}
                    message={t(label + "DELETE-TRANSFORM-QUESTION")}
                    deleteFunc={() => removeTransform(data.path)} />
            }

        </div>
    )
}

export default Transform;